import has from "lodash/has";
import { FilterV2WithIdentifierAndUpdater } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { areValuesEqual, hasDefaultValue, isValueEmpty } from "PFCore/helpers/filters";
import { FilterV2 } from "PFTypes/filters_v2";

export const resolveFilterUpdate = (
  currentFilter: FilterV2,
  updatedFilter: FilterV2WithIdentifierAndUpdater
) => {
  const { value: valueOrUpdater, ...data } = updatedFilter;

  if (!has(updatedFilter, "value")) {
    return { data };
  }

  const mergedFilter = { ...currentFilter, ...data };
  const requestedValue =
    typeof valueOrUpdater === "function" ? valueOrUpdater(currentFilter.value) : valueOrUpdater;

  const value =
    mergedFilter.required && isValueEmpty(requestedValue)
      ? hasDefaultValue(mergedFilter)
        ? mergedFilter.defaultValue
        : currentFilter.value
      : requestedValue;

  if (areValuesEqual(value, currentFilter.value)) {
    return { data };
  }

  const error =
    isValueEmpty(value) || areValuesEqual(value, mergedFilter.defaultValue) ? null : mergedFilter.error;

  return { data, valueChange: { value, error } };
};
